import React from 'react';
import { Helmet } from 'react-helmet-async';
import './EvenementPage.css';

const EvenementPage = () => {
  return (
    <>
      <Helmet>
        <title>The Recap - Nos événements</title>
        <meta name="description" content="Inscrivez-vous aux différents événements The Recap et recevez une restitution claire et actionnable des temps forts : tendances, innovations, stratégies retail et e-commerce." />
        <meta property="og:title" content="The Recap - Nos événements" />
        <meta property="og:description" content="Inscrivez-vous aux différents événements The Recap et recevez une restitution claire et actionnable des temps forts : tendances, innovations, stratégies retail et e-commerce." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className="page-hero evenement-hero" style={{
        background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${process.env.PUBLIC_URL}/images/hero-bg.png) center/cover no-repeat`
      }}>
        <div className="page-hero-overlay">
          <div className="page-hero-content">
            <img src="/images/logo-blanc.png" alt="THE RECAP Logo" className="page-hero-logo fade-in" />
            <h1 className="page-hero-title fade-in">événements</h1>
          </div>
        </div>
      </section>

      <section className="evenement-intro fade-in">
        <div className="evenement-container">
          <h2 className="evenement-subtitle">
            The Recap, ce sont <strong>deux formats</strong> complémentaires : des <strong>Live</strong> pour une restitution rapide et structurée, et des <strong>Dîners</strong> pour aller plus loin, échanger et approfondir les sujets clés.
          </h2>
        </div>
      </section>

      <section className="evenement-events">
        <div className="evenement-container">
          <div className="evenement-card fade-in">
            <div className="evenement-card-image">
              <img src="/images/event-nrf.jpg" alt="The Recap - NRF New York" />
            </div>
            <div className="evenement-card-content">
              <h2 className="evenement-card-title">The Recap - NRF New York</h2>
              <p className="evenement-card-desc">
                <em>Retrouvez tous les temps forts de la NRF 2026 à New York : du dîner exclusif aux visites de magasins innovants.</em>
              </p>
              <div className="evenement-card-buttons">
                <a href="https://photos.app.goo.gl/GWxxTN7KiYsF5zcCA" target="_blank" rel="noopener noreferrer" className="btn-evenement">Le Dîner (Album)</a>
                <a href="https://www.youtube.com/playlist?list=PLTmOUgKc3x9ZneYf_u6Xh-5owzQxSNvYl" target="_blank" rel="noopener noreferrer" className="btn-evenement">Les Store Tour (Vidéos)</a>
                <a href="https://www.linkedin.com/events/therecaplelivenrfnewyork7415434484470525952/theater/" target="_blank" rel="noopener noreferrer" className="btn-evenement">Voir le Live</a>
              </div>
            </div>
          </div>

          <div className="evenement-card fade-in">
            <div className="evenement-card-image">
              <img src="/images/event-shoptalk.jpg" alt="The Recap - Shoptalk Luxe" />
            </div>
            <div className="evenement-card-content">
              <h2 className="evenement-card-title">The Recap - Shoptalk Luxe (Abu Dhabi)</h2>
              <p className="evenement-card-desc">
                <em>Une immersion dans le futur du retail de luxe au Moyen-Orient. Découvrez les concepts stores les plus avancés et le débrief complet.</em>
              </p>
              <div className="evenement-card-buttons">
                <a href="https://www.youtube.com/playlist?list=PLTmOUgKc3x9blrs3GydKbRIhn6beZPhnV" target="_blank" rel="noopener noreferrer" className="btn-evenement">Les Store Tour (Vidéos)</a>
                <a href="https://www.linkedin.com/events/therecapleliveshoptalkluxe7408791973190578176/theater/" target="_blank" rel="noopener noreferrer" className="btn-evenement">Voir le Live</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EvenementPage;
